// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} justifyContent="center" sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Curățenie și întreținere pentru spațiile exterioare
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Oferim servicii profesionale de curățenie și întreținere pentru zonele
                        exterioare ale clădirilor rezidențiale, comerciale și industriale.
                        Intervenim eficient asupra fațadelor, parcărilor și spațiilor verzi,
                        contribuind la menținerea imaginii generale a proprietății și la siguranța
                        utilizatorilor.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
